import { ReactNode } from "react";
import {
  BreadcrumbItem,
  PageBreadcrumb,
} from "src/components/PageBreadcrumb/PageBreadcrumb";
import { PageHeader } from "src/components/PageHeader/PageHeader";

export const ChangeManagementPageLayout = ({
  breadcrumbs,
  rightButtons,
  children,
}: {
  breadcrumbs: BreadcrumbItem[];
  rightButtons?: ReactNode;
  children: ReactNode;
}) => (
  <div className="flex flex-col">
    <PageHeader
      pageTitleComponent={<PageBreadcrumb items={breadcrumbs} />}
      rightButtons={rightButtons}
      rightPanelToggleRequiresDevice={false}
    />
    <main className="flex min-w-0 flex-col gap-6 p-4">{children}</main>
  </div>
);
